module.exports = __webpack_public_path__ + "static/HomepageWomanOnBalcony-mobile-1df975d1d4bd72287a0f3c63370c98ac.jpg";